import { render, staticRenderFns } from "./pruebalistados.vue?vue&type=template&id=05e10a75&"
import script from "./pruebalistados.vue?vue&type=script&lang=js&"
export * from "./pruebalistados.vue?vue&type=script&lang=js&"
import style0 from "./pruebalistados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports